import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as TyreReregistrationOrderActions from './tyre-reregistration-order.action';
import { TyreReregistrationOrderService } from './tyre-reregistration-order.service';
import { OrderService } from '../order/order.service';
import { BannerService } from '../../shared/services/banner.service';
import * as TyreReregistrationOrderModels from '../../models/tyre-reregistration-order/tyre-reregistration-order';
import * as OrderStatusModels from '../../models/order/orderStatus';
import { TyreReregistrationOrderSearchModel } from '../../models/tyre-reregistration-order/tyre-reregistration-orderSearch';
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { SaveState } from '../../models/commonModels';
import { saveAs } from 'file-saver';
import * as Models from '../../models/commonModels';
import { StorageService } from '../../shared/services/storage.service';


export interface TyreReregistrationOrderStateModel {
    OrderStatus: OrderStatusModels.OrderStatusListModel;
    OrderList: TyreReregistrationOrderModels.TyreReregistrationOrderListModel;
    Order: Models.Response<TyreReregistrationOrderModels.TyreReregistrationOrderModel>;
    Search: TyreReregistrationOrderSearchModel;
    Save: SaveState;
    FilteredReportLoading: number;
}

class DictionaryKeys {
  public static readonly OrderStatus = "TyreReregistrationOrderStatus";
}

@State<TyreReregistrationOrderStateModel>({
    name: 'tyreReregistrationOrderState',
    defaults: {
      OrderStatus: null,
      OrderList: null,
      Search: null,
      Save: null,
      Order: null,
      FilteredReportLoading: null
    }
  })

  @Injectable()

  export class TyreReregistrationOrderState {

    constructor(
      private helperService: HelperService,
      private tyreReregistrationOrderService: TyreReregistrationOrderService,
      private orderService: OrderService,
      private bannerService: BannerService,
      private storageService: StorageService
  ) { }

  @Selector()
  static FilteredReportLoading(state: TyreReregistrationOrderStateModel) {
    return state.FilteredReportLoading;
  }

  @Selector()
  static OrderStatus(state: TyreReregistrationOrderStateModel) {
    return state.OrderStatus;
  }

  @Selector()
  static OrderList(state: TyreReregistrationOrderStateModel) {
    return state.OrderList;
  }

  @Selector()
  static Order(state: TyreReregistrationOrderStateModel) {
    return state.Order;
  }

  @Selector()
  static SaveOrder(state: TyreReregistrationOrderStateModel) {
    return state.Save;
  }

  @Selector()
  static OrderSearch(state: TyreReregistrationOrderStateModel) {
    return state.Search;
  }

  @Action(TyreReregistrationOrderActions.GetList)
  GetList(
    context: StateContext<TyreReregistrationOrderStateModel>,
    action: TyreReregistrationOrderActions.GetList
  ) {

    const errorMessage = 'Błąd pobierania listy zleceń przerejestrowania.';

    context.setState(
      patch({
        OrderList: null
      })
    );

    this.tyreReregistrationOrderService.getList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            OrderList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('OrderActions.GetList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(TyreReregistrationOrderActions.SetSearch)
  SetSearch(
    context: StateContext<TyreReregistrationOrderStateModel>,
    action: TyreReregistrationOrderActions.SetSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new TyreReregistrationOrderActions.GetList(action.Search));
  }

  @Action(TyreReregistrationOrderActions.SetListPage)
  SetListPage(
    context: StateContext<TyreReregistrationOrderStateModel>,
    action: TyreReregistrationOrderActions.SetListPage
  ) {

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new TyreReregistrationOrderActions.GetList(action.Search));
  }

  @Action(TyreReregistrationOrderActions.ResetSearch)
  ResetSearch(
    context: StateContext<TyreReregistrationOrderStateModel>
  ) {

    const state = context.getState();

    const search = new TyreReregistrationOrderSearchModel();

    search.ItemsPerPage = state.Search.ItemsPerPage;

    context.setState(
      patch({
        Search: search
      }));

    context.dispatch(new TyreReregistrationOrderActions.GetList(search));
  }

  @Action(TyreReregistrationOrderActions.GetStatusDictionary)
  GetStatusDictionary(
    context: StateContext<TyreReregistrationOrderStateModel>
  ) {

    const errorMessage = 'Błąd pobierania statusów zleceń przerejestrowania opon.';

    let storageKey = DictionaryKeys.OrderStatus;

    context.setState(
      patch({
        OrderStatus: this.storageService.getItemJSON(storageKey)
      })
    );

    const state = context.getState();

    if (!state.OrderStatus) {
      this.tyreReregistrationOrderService.getStatusDictionary().subscribe((ret) => {
        if (ret.Success) {

          context.setState(
            patch({
              OrderStatus: ret
            })
          );

          this.storageService.setItemJSON(storageKey, ret);

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.helperService.SaveException('TyreReregistrationOrderActions.GetStatusDictionary', error);

          this.bannerService.error(errorMessage);
        });
    }
  }

  @Action(TyreReregistrationOrderActions.GetFilteredReport)
  GetFilteredReport(
      context: StateContext<TyreReregistrationOrderStateModel>,
      action: TyreReregistrationOrderActions.GetFilteredReport
   ) {
        function patchContext() {
          context.setState(
            patch ({
              FilteredReportLoading: Math.random()
            })
          );
        }

        const fileName = 'Raport-zlecenia-przerejestrowania';
        this.bannerService.info(`Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`, 'Export danych');

        this.tyreReregistrationOrderService.getFilteredReport(action.Search).subscribe (
              res => {
                const file = new File([res], `${fileName}-${this.helperService.TimeStamp()}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(file);
                patchContext();
              },
              res => {
                patchContext();
                this.bannerService.error(`Błąd pobierania raportu: ${fileName}`);
              },
              () => {
                patchContext();
                this.helperService.consoleLog(' @Action(SaleArticleActions.GetFilteredReport)');
              }
          );
  }

  @Action(TyreReregistrationOrderActions.DisposeSearch)
  DisposeSearch(
    context: StateContext<TyreReregistrationOrderStateModel>
  ) {

    context.setState(
      patch({
        Search: null
      }));
  }

  @Action(TyreReregistrationOrderActions.Set)
  Set(
    context: StateContext<TyreReregistrationOrderStateModel>,
    action: TyreReregistrationOrderActions.Set
  ) {
    const errorMessage = 'Błąd zapisu zmian zlecenia przerejestrowania opon.';

    this.tyreReregistrationOrderService.set(action.Order).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Zapisano zmiany do zlecenia przerejestrowania opon ' + ret.Item.Number + '.');

          context.setState(
            patch({
              Order: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('TyreReregistrationOrderActions.Set', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreReregistrationOrderActions.Get)
  Get(
    context: StateContext<TyreReregistrationOrderStateModel>,
    action: TyreReregistrationOrderActions.Get
  ) {
    const errorMessage = 'Błąd odczytu szczegółów zlecenia przerejestrowania opon.';

    this.tyreReregistrationOrderService.get(action.OrderId).subscribe(
      ret => {

        if (ret.Success) {

          context.setState(
            patch({
              Order: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('TyreReregistrationOrderActions.Get', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }
}
